/* DipaliZ blog posts — reading progress bar (Oct 25, 2026). */
(function () {
  var bar = document.querySelector('.dza-progress span');
  var body = document.querySelector('.dza-body');
  if (!bar || !body) return;
  var tick = false;
  function update() {
    var r = body.getBoundingClientRect();
    var total = r.height - window.innerHeight * 0.5;
    var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
    bar.style.width = (p * 100) + '%';
    tick = false;
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();